import React, { Component } from 'react';
import filesize from 'filesize';
import styled from 'styled-components';
import MaterialIcon from 'material-icons-react';
import Icons from 'components/Icons';
import Theme from 'Theme';
import { fadeIn } from 'components/Animations';

export class PendingFile extends Component {
  render() {
    const { file, description, onFileDelete } = this.props;

    const filename = !!file && (file.name || '');
    const size = !!file && file.size;

    return (
      <Collapse isOpen={!!file}>
        <FileContain>
          <ItemContain>
            <Flex>
              <IconOffset>
                <Icons.Order size={48} />
              </IconOffset>
              <Text>
                <PrimaryLine>{description}</PrimaryLine>
                <SecondaryLine>{filename}</SecondaryLine>
                <SecondaryLine fontWeight={300}>
                  {!!size && filesize(size).toLowerCase()}
                </SecondaryLine>
              </Text>
              <Cancel onClick={onFileDelete}>
                <MaterialIcon
                  icon="remove_circle_outline"
                  color={Theme.inactiveColor}
                  size="small"
                />
              </Cancel>
            </Flex>
          </ItemContain>
        </FileContain>
      </Collapse>
    );
  }
}

const Collapse = styled.div`
  display: none;
  ${fadeIn}
  ${(props) =>
    props.isOpen &&
    `
    display: block;
  `}
`;

const FileContain = styled.div`
  margin-bottom: 16px;
`;

const IconOffset = styled.div`
  position: relative;
  top: 4px;
`;

const ItemContain = styled.div`
  border-style: solid;
  border-width: 1px;
  border-color: rgba(245, 245, 245, 1);
  margin-right: 4px;
  border-radius: 4px;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  padding: 16px;
`;

const Text = styled.div`
  flex: 1;
  margin-left: 16px;
  font-family: ${Theme.primaryFont};
`;

export const PrimaryLine = styled.div`
  font-weight: 400;
  font-size: 18px;
  line-height: 1.5em;
  font-family: ${Theme.primaryFont};
`;

export const SecondaryLine = styled.div`
  font-size: 16px;
  line-height: 1.5em;
  font-weight: ${(props) => props.fontWeight || 400};
  color: grey;
  font-family: ${Theme.primaryFont};
`;

const Cancel = styled.div`
  cursor: pointer;

  i {
    transition: all 250ms ease-in-out;
    -webkit-transition: all 250ms ease-in-out;
  }

  &:hover i {
    color: ${Theme.dangerColor} !important;
  }
`;

export default PendingFile;
